import React from 'react';
import { getHistory } from 'store/store';
import UrlUtils from '@spothero/utils/url';
import { Box, Flex, Text } from '@spothero/ui';
import { Select } from '@spothero/ui-backlog';
import MobileToggle from 'common/search-filters-controls/mobile-toggle';
import useIsMobile from 'hooks/use-is-mobile';
import { COLONIAL_OPERATOR_ID, OPERATOR_LOYALTY_PROGRAM } from 'common/constants';
const SpotListSorter = ({ operatorId, numberOfSpots, sortBy, onChangeSort, sortSelectItems, showMobileToggle = true, }) => {
    const history = getHistory();
    const { filter_by } = UrlUtils.parseParams(history?.location?.search);
    const isMobile = useIsMobile();
    const getText = () => {
        if (filter_by === OPERATOR_LOYALTY_PROGRAM) {
            return `${numberOfSpots} ColonialFlex™️ Facilities`;
        }
        return `${numberOfSpots} Results`;
    };
    return (<Flex display={operatorId ? 'flex' : 'block'} justify="space-between">
            {operatorId === COLONIAL_OPERATOR_ID && (<Flex className="SpotListSorter-text" alignItems="center" mt={{ base: 2, desktop: 4 }} mb={{ base: 3, desktop: 0 }}>
                    <Text fontWeight="bold" pl={5}>
                        {getText()}
                    </Text>
                </Flex>)}
            <Flex className="SpotListSorter" alignItems="center" justify={isMobile ? 'space-between' : 'flex-end'} sx={{
            '.Select-dropdown-icon': {
                height: 'auto',
                width: '16px',
            },
        }}>
                {isMobile && showMobileToggle ? <MobileToggle /> : <Box />}
                <Select value={sortBy} onChange={onChangeSort} items={sortSelectItems} data-testid="SpotListSorter-select"/>
            </Flex>
        </Flex>);
};
export default SpotListSorter;
